import * as PlotSteps from "@frog/source/data/plot/steps.js"

// "horror-axe": require("@frog/source/assets/images/horror-tactics/units/weapon.axe.png"),
// "horror-knife": require("@frog/source/assets/images/horror-tactics/units/weapon.knife-blue.png"),
// "horror-candelabra": require("@frog/source/assets/images/horror-tactics/units/weapon.candelabra.png"),
// "horror-crucifix": require("@frog/source/assets/images/horror-tactics/units/weapon.crucifix-alt.png"),
// "horror-gun": require("@frog/source/assets/images/horror-tactics/units/weapon.gun.png"),
// "horror-shovel": require("@frog/source/assets/images/horror-tactics/units/weapon.shovel.png"),

export default {
    "affiliation": "good",
    "phase": "observe", // initial player phase
    "timeout": 5 * 60 * 1000, // initial player timeout
    "inventory": {
        "items": {
            "crucifix": {
                "key": "crucifix",
                "name": "Crucifix",
                "element": "water",
                "skillKeys": ["book/brandish", "book/unbrandish"],
                "weaponImageKey": "ember-crucifix",
            },
            "lantern": {
                "key": "lantern",
                "name": "Lantern",
                "element": "fire",
                "skillKeys": ["book/brandish", "book/unbrandish"],
                "weaponImageKey": "horror-candelabra",
            },
            "mirror": {
                "key": "mirror",
                "name": "Mirror",
                "element": "earth",
                "skillKeys": ["book/brandish", "book/unbrandish"],
                "weaponImageKey": "horror-shovel",
            },
            "salt": {
                "key": "salt",
                "name": "Salt",
                "skillKeys": ["book/salt"], // TODO: "book/scatter"
            },
            "sulfur": {
                "key": "sulfur",
                "name": "Sulfur",
                "skillKeys": ["book/sulfur"], // TODO: "book/scatter"
            },
            "silver": {
                "key": "silver",
                "name": "Silver",
                "skillKeys": ["book/silver"], // TODO: "book/scatter"
            },
        }
    },
    "party": {
        "units": {
            "ashe": {
                "key": "ashe",
                "name": "Tucker",
                "affiliation": "good",
                "isRecruited": true,

                "maxhealth": 60,
                "moverange": 2,

                "equippedItem": null,
                // "primaryItem":  {
                //     "key": "crucifix",
                //     "name": "Crucifix",
                //     "skillKeys": ["book/brandish", "book/unbrandish"],
                //     "weaponImageKey": "ember-sword",
                // },
                // "secondaryItem": {
                //     "name": "Silver",
                //     "skillKeys": ["book/silver"],
                // },
                // "tertiaryItem": {
                //     "name": "Ritual",
                //     "skillKeys": ["book/ritual"],
                // },
                "items": {
                    "crucifix": {
                        "element": "water",
                        "key": "crucifix",
                        "name": "Crucifix",
                        "skillKeys": ["book/brandish", "book/unbrandish"],
                        "weaponImage": require("@frog/source/assets/images/book-tactics/ludum-handheld-crucifix.png")
                    },
                    "lantern": {
                        "element": "fire",
                        "key": "lantern",
                        "name": "Lantern",
                        "skillKeys": ["book/brandish", "book/unbrandish"],
                        "weaponImage": require("@frog/source/assets/images/book-tactics/ludum-handheld-flashlight.png")
                    },
                    "mirror": {
                        "element": "earth",
                        "key": "mirror",
                        "name": "Mirror",
                        "skillKeys": ["book/brandish", "book/unbrandish"],
                        "weaponImage": require("@frog/source/assets/images/book-tactics/ludum-handheld-mirror.png")
                    },
                    // "salt": {
                    //     "key": "salt",
                    //     "name": "Salt",
                    //     "skillKeys": ["book/salt"], // TODO: "book/scatter"
                    // },
                    // "sulfur": {
                    //     "key": "sulfur",
                    //     "name": "Sulfur",
                    //     "skillKeys": ["book/sulfur"], // TODO: "book/scatter"
                    // },
                    // "silver": {
                    //     "key": "silver",
                    //     "name": "Silver",
                    //     "skillKeys": ["book/silver"], // TODO: "book/scatter"
                    // },
                    // "ritual": {
                    //     "name": "Ritual",
                    //     "skillKeys": ["book/ritual"],
                    // },
                },

                "skillKeys": [
                    "book/salt",
                    "book/sulfur",
                    "book/silver",
                    "book/ritual",
                    "ember/kindle",
                ],

                "scripts": {
                    "death": [
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        "ASHE: Damn, not like this...",
                    ]
                },

                "stack": 1,
                // "imageKey": "occultist",
                "spriteSize": "4x3",
                "animationKey": "breathing",
                "sprites": {
                    "idle": {
                        "parts": [
                            {"stack": 10, "type": "head", "image": require("@frog/source/assets/images/book-tactics/fucker/sprite-ludumPC-10-head-0000.png")},
                            {"stack": 10, "type": "head", "image": require("@frog/source/assets/images/book-tactics/fucker/sprite-ludumPC-10-head-0001.png")},
                            {"stack": 10, "type": "head", "image": require("@frog/source/assets/images/book-tactics/fucker/sprite-ludumPC-10-head-0002.png")},
                            {"stack": 20, "type": "body", "image": require("@frog/source/assets/images/book-tactics/fucker/sprite-ludumPC-20-body.png")},
                            {"stack": 30, "type": "legs", "image": require("@frog/source/assets/images/book-tactics/fucker/sprite-ludumPC-30-legs.png")},
                            {"stack": 110, "type": "head", "image": require("@frog/source/assets/images/book-tactics/fucker/sprite-ludumPC-outline-10-head.png")},
                            {"stack": 120, "type": "body", "image": require("@frog/source/assets/images/book-tactics/fucker/sprite-ludumPC-outline-20-body.png")},
                            {"stack": 130, "type": "legs", "image": require("@frog/source/assets/images/book-tactics/fucker/sprite-ludumPC-outline-30-legs.png")},
                            {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                            {"stack": 210, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
                        ],
                    }
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/book-tactics/ludum-portraits-PC.png"),
                },
            },
            "gwyn": {
                "key": "gwyn",
                "name": "Gwyn",
                "affiliation": "good",
                "isRecruited": true,

                "maxhealth": 40,
                "moverange": 3,

                "equippedItem": null,
                "primaryItem": {
                    "key": "lantern",
                    "name": "Lantern",
                    "skillKeys": ["book/brandish", "book/unbrandish"],
                    "weaponImageKey": "ember-axe",
                },
                "secondaryItem": {
                    "key": "sulfur",
                    "name": "Sulfur",
                    "skillKeys": ["book/sulfur"],
                },
                "tertiaryItem": {
                    "name": "Ritual",
                    "skillKeys": ["book/ritual"],
                },

                "skillKeys": [
                    "pull",
                    "ember/kindle",
                ],

                "scripts": {
                    "death": [
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        "Gywn: Ah, these things happen.",
                    ]
                },

                "stack": 1,
                "imageKey": "priest",
                // "spriteSize": "4x3",
                // "animationKey": "breathing",
                // "sprites": {
                //     "idle": {
                //         "parts": [
                //             {"stack": 10, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-10-body.png")},
                //             {"stack": 20, "type": "head", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-20-head-0002.png")},
                //             {"stack": 30, "type": "legs", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-30-legs.png")},
                //             {"stack": 110, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-outline-10-body.png")},
                //             {"stack": 120, "type": "head", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-outline-20-head.png")},
                //             {"stack": 130, "type": "legs", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/gwyn/sprite-gwyn-outline-30-legs.png")},
                //             {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                //             {"stack": 210, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
                //         ],
                //     }
                // },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/ember-tactics/portraits/portraits-ember-gwyn.png"),
                },
            },
            "ylfa": {
                "key": "ylfa",
                "name": "Ylfa",
                "affiliation": "good",
                "isRecruited": true,

                "maxhealth": 40,
                "moverange": 2,

                "equippedItem": null,
                "primaryItem": {
                    "key": "mirror",
                    "name": "Mirror",
                    "skillKeys": ["book/brandish", "book/unbrandish"],
                    "weaponImageKey": "ember-spear",
                },
                "secondaryItem": {
                    "key": "salt",
                    "name": "Salt",
                    "skillKeys": ["book/salt"], // TODO: "book/scatter"
                },
                "tertiaryItem": {
                    "name": "Ritual",
                    "skillKeys": ["book/ritual"],
                },

                "skillKeys": [
                    "push",
                    "ember/kindle",
                ],

                "scripts": {
                    "death": [
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        "YLFA: :((((",
                    ]
                },

                "stack": 1,
                "imageKey": "professor",
                // "spriteSize": "4x3",
                // "animationKey": "breathing",
                // "sprites": {
                //     "idle": {
                //         "parts": [
                //             {"stack": 0, "type": "head", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-10-head-0002.png")},
                //             {"stack": 20, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-20-body.png")},
                //             {"stack": 30, "type": "legs", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-30-legs.png")},
                //             {"stack": 110, "type": "head", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-outline-10-head.png")},
                //             {"stack": 120, "type": "body", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-outline-20-body.png")},
                //             {"stack": 130, "type": "legs", "image": require("@frog/source/assets/images/ember-tactics/sprites/characters/ylfa/sprite-ylfa-outline-30-legs.png")},
                //             {"stack": 200, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-shadow.png")},
                //             {"stack": 210, "image": require("@frog/source/assets/images/ember-tactics/sprites/sprite-test-glow.png")},
                //         ],
                //     }
                // },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/ember-tactics/portraits/portraits-ember-ylfa.png"),
                },
            },
        },
    },
}
